<h1 *ngIf="step == 1" mat-dialog-title>Crear Valet Parking {{ step }}/2: Arrastre la pantalla para seleccionar un punto</h1>
<h1 *ngIf="step == 2" mat-dialog-title>Crear Valet Parking {{ step }}/2: Ingrese un número telefónico de notificación</h1>
<div mat-dialog-content>
  <ng-container [ngSwitch]="step">
    <div *ngSwitchCase="1" class="button-group">
      <button mat-button *ngFor="let option of options; let i = index"
              [ngClass]="{'selected': selectedOption === option}"
              (click)="selectOption(option)">
        {{ option }}
        </button>
    </div>
    <div class="form-flex" *ngSwitchCase="2">
      <mat-form-field appearance="fill">
        <mat-label>Correo</mat-label>
        <input matInput [(ngModel)]="mail">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Teléfono</mat-label>
        <input matInput [(ngModel)]="phone">
      </mat-form-field>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="prevStep()" *ngIf="step > 1">Atras</button>
  <button mat-button (click)="nextStep()" *ngIf="step < 2">Siguiente</button>
  <button mat-button (click)="SendData()" *ngIf="step === 2">Crear</button>
  <button mat-button (click)="CloseDialog()" >Cancelar</button>
</div>
